import { Classificazione } from '../classificazione';
import { Sezione } from './sezione';

export class ClassificazioneSezione extends Sezione {
  classificazioni: Classificazione[];
}

